module.exports = __webpack_public_path__ + "static/media/netlify.d908acb2.svg";